import { useContext, useEffect, useState } from "react";
import { ContextProvider } from "../../App";
import { domainUrl } from "../utils/constant";

const useMenuData = (parsedId) => {
  // console.log(parsedId);
  const [menuData, setMenuData] = useState([]);
  const { setShowLoader } = useContext(ContextProvider);
  // console.log(menuData);

  useEffect(() => {
    getMenuData();
  }, [parsedId]); // Dependency on parsedId

  async function getMenuData() {
    try {
      setShowLoader(true);
      const response = await fetch(`${domainUrl}/getProduct/${parsedId}`); // Use template literal with parsedId

      if (!response.ok) {
        throw new Error("API Internal Error");
      }
      const json = await response.json();
      setMenuData(json); // Assuming json.products holds the menu data
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  }

  return { menuData };
};

export default useMenuData;
